export default __webpack_public_path__ + "static/media/wwf_mobile.fcbfb137.jpg";